"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useABTest = void 0;
const common_components_1 = require("@as-react/common-components");
const common_utils_1 = require("@as-react/common-utils");
// This hook provides us with 3 properties:
// 1. getCookie: returns the value of the AB test cookie
// 2. hasBCookie: returns true if the cookie value is 'B'
// 3. hasCCookie: returns true if the cookie value is 'C'
const useABTest = (abTestCookie) => {
    const abContext = (0, common_components_1.useABContextWrapper)();
    const hybridCookieUtil = new common_utils_1.HybridCookieUtil();
    return typeof document !== 'undefined'
        ? {
            getCookie: hybridCookieUtil.getCookie(abTestCookie),
            hasBCookie: hybridCookieUtil.hasBCookie(abTestCookie),
            hasCCookie: hybridCookieUtil.hasCCookie(abTestCookie),
        }
        : {
            getCookie: abContext === null || abContext === void 0 ? void 0 : abContext[abTestCookie],
            hasBCookie: abContext === null || abContext === void 0 ? void 0 : abContext[abTestCookie],
            hasCCookie: abContext === null || abContext === void 0 ? void 0 : abContext[abTestCookie],
        };
};
exports.useABTest = useABTest;
